const alertStyleDecorator = (alertStyle, style, theme) => {
  switch (alertStyle) {
    case 'error':
      {
        return {
          ...style,
          '&.MuiAlert-outlinedError': {
            backgroundColor: theme.tokens.ComponentAlertErrorBg,
            borderColor: theme.tokens.ComponentAlertErrorBorder,
            borderRadius: theme.tokens.ComponentAlertErrorRadius,
            borderWidth: '1px 1px 1px 8px',
            borderStyle: 'solid',
            color: theme.tokens.ComponentAlertFontColor
          },
          '.alert-link-btn': {
            color: theme.tokens.ComponentAlertErrorLinkColor
          },
          '.MuiAlert-icon': {
            color: theme.tokens.ComponentAlertErrorBorder
          }
        };
      }
    case 'info':
      {
        return {
          ...style,
          '&.MuiAlert-outlinedInfo': {
            backgroundColor: theme.tokens.ComponentAlertInfoBg,
            borderColor: theme.tokens.ComponentAlertInfoBorder,
            borderWidth: '1px 1px 1px 8px',
            borderStyle: 'solid',
            borderRadius: theme.tokens.ComponentAlertInfoRadius,
            color: theme.tokens.ComponentAlertFontColor
          },
          '.alert-link-btn': {
            color: theme.tokens.ComponentAlertInfoLinkColor
          },
          '.MuiAlert-icon': {
            color: theme.tokens.ComponentAlertInfoBorder
          }
        };
      }
    case 'success':
      {
        return {
          ...style,
          '&.MuiAlert-outlinedSuccess': {
            backgroundColor: theme.tokens.ComponentAlertSuccessBg,
            borderColor: theme.tokens.ComponentAlertSuccessBorder,
            borderWidth: '1px 1px 1px 8px',
            borderStyle: 'solid',
            borderRadius: theme.tokens.ComponentAlertSuccessRadius,
            color: theme.tokens.ComponentAlertFontColor
          },
          '.alert-link-btn': {
            color: theme.tokens.ComponentAlertSuccessLinkColor
          },
          '.MuiAlert-icon': {
            color: theme.tokens.ComponentAlertSuccessBorder
          }
        };
      }
    case 'caution':
      {
        return {
          ...style,
          '&.MuiAlert-outlinedWarning': {
            backgroundColor: theme.tokens.ComponentAlertCautionBg,
            borderColor: theme.tokens.ComponentAlertCautionBorder,
            borderWidth: '1px 1px 1px 8px',
            borderStyle: 'solid',
            borderRadius: theme.tokens.ComponentAlertCautionRadius,
            color: theme.tokens.ComponentAlertFontColor
          },
          '.alert-link-btn': {
            color: theme.tokens.ComponentAlertCautionLinkColor
          },
          '.MuiAlert-icon': {
            color: theme.tokens.ComponentAlertCautionBorder
          }
        };
      }
    default:
      return {
        ...style
      };
  }
};
export default alertStyleDecorator;